'use client';
import type { PropsWithChildren } from 'react';
import { AsideBlock } from '~/app/_components/aside-block';
import type { DetailLink } from '~/app/_components/aside-block';
import { css, cva } from '@styled-system/css';
import { Flex } from '@styled-system/jsx';
import bigArrow from './assets/arrow-big.png';
import { useLocalHooks } from './use-local-hooks';

type Props = PropsWithChildren<{
  title: string;
  detailLink?: DetailLink;
}>;

export const SeriesCarousel = ({ title, detailLink, children }: Props) => {
  const { showRightArrow, showLeftArrow, scroll, seriesRef } = useLocalHooks();

  return (
    <AsideBlock title={title} detailLink={detailLink}>
      <Flex position="relative" width="100%">
        {showLeftArrow && (
          <button
            onClick={() => scroll(false)}
            className={scrollButtonStyles({ position: 'previousPage' })}
          >
            <img
              className={css({
                width: '10px',
                cursor: 'pointer',
                transform: 'rotate(180deg)',
                verticalAlign: 'middle',
                marginRight: '35px',
                display: 'inline-block',
                _hover: {
                  opacity: '0.8',
                },
              })}
              src={bigArrow}
              alt="前のページ"
            />
          </button>
        )}
        <Flex gap="5px" overflowX="auto" marginTop="12px" ref={seriesRef}>
          {children}
        </Flex>

        {showRightArrow && (
          <button
            onClick={() => scroll(true)}
            className={scrollButtonStyles({ position: 'nextPage' })}
          >
            <img
              className={css({
                maxWidth: '100%',
                verticalAlign: 'middle',
                marginLeft: '35px',
                width: '10px',
                cursor: 'pointer',
                display: 'inline-block',
                _hover: {
                  opacity: '0.8',
                },
              })}
              src={bigArrow}
              alt="前のページ"
            />
          </button>
        )}
      </Flex>
    </AsideBlock>
  );
};

const scrollButtonStyles = cva({
  base: {
    display: {
      base: 'none',
      lg: 'block',
    },
    position: 'absolute',
    width: '100px',
    height: '180px',
    outline: 'none',
    cursor: 'pointer',
    zIndex: '9',
    opacity: '0',
    transition: 'opacity 0.2s ease-out',
    _hover: {
      '& img': {
        opacity: '0.7',
      },
    },
  },
  variants: {
    position: {
      previousPage: {
        backgroundImage:
          'linear-gradient(-90deg, #fff 0%, rgba(250, 250, 250, 0) 0.01%, #fafafa 38.02%)',
        left: '-30px',
      },
      nextPage: {
        backgroundImage:
          'linear-gradient(90deg, #fff 0%, rgba(250, 250, 250, 0) 0.01%, #fafafa 38.02%)',
        right: '-30px',
      },
    },
  },
});
